import Vue from 'vue'
import VueRouter from 'vue-router'
import reportRoutes from './modules/report'
import customerServiceRoutes from './modules/customerService'

Vue.use(VueRouter)

const baseRoutes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('@/views/login'),
    meta: {
      title: '登录',
    }
  }
]

// 所有模块路由
const moduleRoutes = []
moduleRoutes.push.apply(moduleRoutes, reportRoutes)
moduleRoutes.push.apply(moduleRoutes, customerServiceRoutes)

// 最终路由
const routes = baseRoutes.concat(moduleRoutes)

const router = new VueRouter({
  routes
})

export default router
